import { ComponentRef } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import { Modal } from './modal.model';
import { ModalContainerComponent } from './components/modal-container/modal-container.component';

declare var UIkit: any;

export class ModalRef {

    private result$ = new Subject<any>();

    constructor(
        private modalContainer: ComponentRef<ModalContainerComponent>,
        private modal: ComponentRef<Modal>,
    ) {
        this.modal.instance.modalInstance = this;
    }

    close(output: any): void {
        this.result$.next(output);
        this.destroy$();
    }

    dismiss(output: any): void {
        this.result$.error(output);
        this.destroy$();
    }

    onResult(): Observable<any> {
        return this.result$.asObservable();
    }

    private destroy$(): void {
        this.modal.destroy();
        this.modalContainer.destroy();
        this.result$.complete();
        this.closeUIKitModal();
    }

    private closeUIKitModal() {
        if (typeof document.querySelector('#modal-container').remove === 'function') {
            document.querySelectorAll('#modal-container').forEach(ele => {
                ele.remove();
            });
        } else {
            document.querySelector('#modal-container').outerHTML = '';
        }
    }
}
